import React, { Component } from "react";
import "../../css/FilterBarModal.css";
import { connect } from "react-redux";
import { chosenFilter } from "../../models";
import { Translation } from "react-i18next";

class FilterBarModal extends Component {
  remove = data => {
    const { removeFilter, activeSortBy, keywords } = this.props;
    // 移除陣列中的自己
    removeFilter(data, keywords, activeSortBy);
  };
  clearAll = () => {
    const { activeSortBy, keywords, clearAllFilter } = this.props;
    clearAllFilter(keywords, activeSortBy);
  };
  useAllFilter = () => {
    // 套用所有項目，並關閉所有Modal
    this.props.closeModal();
    this.props.closeParentModal();
  };
  render() {
    const {
      active,
      closeModal,
      title,
      content,
      chosenFilterList,
      hidenFooter
    } = this.props;
    return (
      <div
        className={`filter-modal-background ${
          active ? "filter-background-opened" : ""
        } `}
      >
        <div className={`filter-modal ${active ? "filter-modal-opened" : ""}`}>
          <div className="filter-modal-content">
            <div className="filter-modal-head">
              <button
                className="filter-modal-close"
                onClick={closeModal}
              ></button>
              <span className="filter-modal-title">{title}</span>
            </div>
            <div className="filter-modal-body">{content}</div>
            {!hidenFooter && (
              <div className="filter-modal-footer">
                {chosenFilterList.length > 0 ? (
                  <div>
                    <div className="mobile-choosen-options">
                      <button
                        className="cancel-all-filters"
                        onClick={this.clearAll}
                      >
                        <Translation>
                          {t => <>{t("searchPage.cancelAll")}</>}
                        </Translation>
                      </button>
                      {chosenFilterList.map((data, index) => (
                        <span className="choosen-filter-option" key={index}>
                          <button
                            className="choosen-filter-close-btn"
                            onClick={this.remove.bind(this, data)}
                          ></button>
                          <span className="choosen-filter-name">
                            {data.name}
                          </span>
                        </span>
                      ))}
                    </div>
                    <button
                      className="apply-all-filter-btn"
                      onClick={this.useAllFilter}
                    >
                      <Translation>
                        {t => <>{t("searchPage.applyAll")}</>}
                      </Translation>
                    </button>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

FilterBarModal.defaultProps = {
  active: false,
  closeModal: () => {},
  closeParentModal: () => {},
  title: "",
  hidenFooter: false,
  content: ""
};

const mapStateToProps = state => {
  return {
    chosenFilterList: state.chosenFilter.chosenFilterList,
    activeSortBy: state.sortByFilter.activeSortBy
  };
};

const mapDispatchToProps = () => {
  return {
    removeFilter: (data, keywords, activeSortBy) =>
      chosenFilter.actions.removeFilter(data, keywords, activeSortBy),
    clearAllFilter: (keywords, activeSortBy) =>
      chosenFilter.actions.clearAllFilter(keywords, activeSortBy)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBarModal);
